import React from "react";
import cx from "classnames";

const TabBar = (props) => {
  // Tabs may be plain strings or objects of the form { id, label, showTag }.
  const normalizeTab = (tab) =>
    typeof tab === "object" ? tab : { id: tab, label: tab, showTag: false };

  const renderTag = (tab) => {
    if (tab.showTag) {
      return (
        <div
          className="tag tag--small tag--orange"
          style={{ position: "relative", top: -2, marginLeft: 5 }}
        >
          <i className="solid solid-budicon-alert" />
        </div>
      );
    }
  };

  return (
    <div className={cx("tabs__container", { "tabs__container--no-mgn": props.noMargin })}>
      {props.tabs.map((rawTab) => {
        const tab = normalizeTab(rawTab);

        return (
          <div
            key={tab.id}
            className={tab.id === props.activeTab ? "tabs__item tabs__item--active" : "tabs__item"}
            onClick={() => props.setActiveTab(tab.id)}
          >
            {tab.label}
            {renderTag(tab)}
          </div>
        );
      })}
    </div>
  );
};

export default TabBar;
